<section class="vh-100 d-flex align-items-center justify-content-center body-container">
  <div class="container-fluid text-center">
    <img src="assets/images/404.png" alt="404 Error" class="img-fluid">
    <div class="container">
      <button class="btn button-login" (click)="goToLoginPage()">
        <i class="fa fa-arrow-circle-left" aria-hidden="true"></i>
        Go back to login
      </button>
    </div>
  </div>

</section>
